module.exports = __webpack_public_path__ + "static/media/Hamburger.67deb0ff.svg";